import { Step } from "react-joyride";
import { PortalTourActionType } from "./PortalTourActionType";
import { canViewInsights, canViewStaff } from "ft-shared-graphql";
export const mainMenuSteps: Record<string, { label: string; steps: Step[], onSkip?: string }> = {
    mainMenu: {
        label: "Main Menu",
        onSkip: "mainMenu",
        steps: [
            {
                target: '[data-tour="manage-staff-link"]',
                content: "Manage Staff here.",
                data: {
                    access: canViewStaff
                }
            },
            {
                target: '[data-tour="company-information"]',
                content: "View company information, like parental consent and intervention policies, subscriptions, and locations.",
                data: {
                    // route: '/dashboard',
                    access: canViewInsights
                }
            },
            {
                target: '[data-tour="student-insights"]',
                content: "View Insights on your children like age range, age vs Anxiety/Depression markers, top Positive Childhood Experiences, and more.",
                data: {
                    //  route: '/dashboard', 
                    access: canViewInsights
                }
            },
            {
                target: '[data-tour="change-location"]',
                content: "If you work at more than one location, change location here to view children at other locations. At the moment you cannot view all children across locations at once.",
                data: { condition: "location" }
            },
            {
                target: '[data-tour="user-guides"]',
                content: "Find the User Manual, sample videos for consent and triage explanation here.",
                data: {
                    // route: '/dashboard',
                    action: "mainMenu"
                }
            },
            {
                target: '[data-tour="guided-tutorials"]',
                content: "If you need to reference these tutorials again, find them here.",
                data: {
                    action: "mainMenu"
                }
            }
        ]
    },
    nextSectionReports: {
        label: "Reports",
        steps: [
            {
                target: '[data-tour="report-view"]',
                content: "Let's take a look at the report's page",
                data: {
                    //  route: "/dashboard",
                    action: "goToReports"
                }

            }]
    }

}

